// extracted by css-extract-rspack-plugin
export default {"triggerButton":"NDbgO"};